import { Component, OnInit } from "@angular/core";
import { CPartnerOrganization } from "../../../models/company.models/partnerOrganization.model";
import { PartnerOrganizationService } from "../../../services/partnerOrganization.service";
import { API_ServerAddress } from "../../../MyAppCommonConfig";

@Component({
  selector: "insurancesSlider",
  templateUrl: "insurancesSlider.component.html",
})
export class InsurancesSliderComponent implements OnInit {
  ngOnInit(): void {
    this.GetPartnerOrganizationArray();
  }

  partnerOrganizationArray: CPartnerOrganization[] = [];
  ApiServiceAddress: string;
  showSlider: boolean = false;

  loadAPI: Promise<any>;

  constructor(private partnerOrganizationService: PartnerOrganizationService) {
    this.ApiServiceAddress = API_ServerAddress;
  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; ++i) {
      if (
        scripts[i].getAttribute("src") != null &&
        scripts[i].getAttribute("src").includes("jssor.slider")
      ) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = [
        "/assets/js/jssor.slider-27.5.0.min.js",
        "/assets/js/insuranceSlide.js",
      ];

      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement("script");
        node.src = dynamicScripts[i];
        node.type = "text/javascript";
        node.async = false;
        node.charset = "utf-8";
        document.getElementsByTagName("head")[0].appendChild(node);
      }
    }

    //فعال کردن اسلایدر
    var sliderInitScripts = ["/assets/js/insuranceSlideInit.js"];

    for (var i = 0; i < sliderInitScripts.length; i++) {
      let node2 = document.createElement("script");
      node2.src = sliderInitScripts[i];
      node2.type = "text/javascript";
      node2.async = false;
      node2.charset = "utf-8";
      document.getElementsByTagName("head")[0].appendChild(node2);
    }
  }

  GetPartnerOrganizationArray() {
    this.partnerOrganizationService
      .GetList()
      .subscribe((data: CPartnerOrganization[]) => {
        this.partnerOrganizationArray = data;
        if (this.partnerOrganizationArray.length > 3) {
          this.showSlider = true;

          this.loadAPI = new Promise((resolve) => {
            this.loadScript();
            resolve(true);
          });
        }
      });
  }
}
